import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed, defineAsyncComponent } from 'vue';
import { useHomeStore } from '@/pinia/home';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcePkg',
  setup(__props) {

const homeStore = useHomeStore();
const NewResourceBuy = defineAsyncComponent(() => import('./ResourceBuy/NewResourceBuy.vue'));
const OldResourceBuy = defineAsyncComponent(() => import('./ResourceBuy/OldResourceBuy.vue'));

const SHOWVIEW = {
  OLDRESOURCEBUY: true,
  NEWRESOURCEBUY: false,
};
const showVersion = computed(() => (homeStore.isNewVersion ? SHOWVIEW.NEWRESOURCEBUY : SHOWVIEW.OLDRESOURCEBUY));

return (_ctx: any,_cache: any) => {
  return (_unref(showVersion))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(OldResourceBuy))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_unref(NewResourceBuy))
      ]))
}
}

})